import { useEffect } from 'react';
import useNewItemChange from '../../EHR Settings/Templates/OpenTemplate/FormBuilder/hooks/useNewItemChange';
import { Separator } from '../../utils/utils';

const Table = ({ item, setItem, activeAccordion }) => {
    const headers = item.headers ? item.headers.split(Separator) : [];
    const rows = item.rows ?
        item.rows?.split("\n") ? item.rows?.split("\n") : item.rows?.split("\n") :
        [];

    // console.log("rowsTable",rows)
    const anyValExist = rows.some(row => row.split(Separator)?.some(cell => cell.trim() !== ''))
    // console.log("rowsTable",anyValExist)
    return (
        <div className='table-view template-acordian d-flex gap-15'>
            <label htmlFor="" className="text fs-14 ar-light-color w-231px text-end flex-shrink-0">{item.content}</label>
            {console.log("Rows", rows)}
            {anyValExist ?
                <div className="overflow-auto">
                    <table className='templates-table output' >
                        <thead>
                            <tr>
                                {headers.length > 0 &&
                                    (headers.map((header, index) => (
                                        <th key={index} className='text-black font-m fw-500 text w-auto'>{header}</th>
                                    )))}
                            </tr>
                        </thead>
                        <tbody>
                            {Array.from({ length: item.noOfRows || 2 }).map((_, rowIndex) => (
                                <tr key={rowIndex}>
                                    {rows?.[rowIndex]?.length > 0 &&
                                        (rows?.[rowIndex]?.split(Separator).length > 0 &&
                                            (rows?.[rowIndex]?.split(Separator).map((rowItem, cellIndex) => (
                                                <td key={cellIndex} className='text-black text w-auto'>
                                                    {rowItem}
                                                </td>)

                                            )))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                :
                <p className="text text-black fs-14">N/A</p>}
        </div >
    );
};

export default Table